<template>
  <div class="ExamResultInfo login">
    <TopNavBar navtitle="成绩查询"></TopNavBar>

    <div class="enrolllist">
      <van-cell-group>
        <van-field
          v-model="Name"
          label="考生姓名"
          left-icon="user-o"
          placeholder="请输入考生姓名"
        />
        <van-field
          v-model="CertNO"
          clearable
          label="证件号"
          left-icon="idcard"
          placeholder="请输入有效证件号码"
          error-message="身份证/护照/港澳通行证"
        />
        <div class="ExamResultbtn">
          <!-- <p>仅供本人免费查询成绩</p> -->
          <van-button type="primary" size="normal" @click="GetExamList"
            >立即查询</van-button
          >
        </div>
      </van-cell-group>
      <ul v-for="(item, index) in resultList" :key="index">
        <h1>{{ item.ExamBatch.EB_Name }}</h1>
        <img class="papers" :src="item.Photo" alt="" />
        <li>
          <label for=""><i class="iconfont icon-baoming"></i>报考人：</label>
          <span>{{ item.Name }}</span>
        </li>
        <li>
          <label for=""><i class="iconfont icon-zhuanye"></i>报考专业：</label>
          <span>{{ item.Majors.MName }}</span>
        </li>
        <li>
          <label for=""><i class="iconfont icon-dengji"></i>报考等级：</label>
          <span>{{ item.Grades.GName }}</span>
        </li>
        <li>
          <label for=""><i class="iconfont icon-chengji"></i>考试成绩：</label>
          <van-tag v-if="item.ExamResult.ERT_Code == 4" round type="success"
            >优秀</van-tag
          >
          <van-tag v-if="item.ExamResult.ERT_Code == 3" round type="success"
            >良好</van-tag
          >
          <van-tag v-if="item.ExamResult.ERT_Code == 2" round type="warning"
            >及格</van-tag
          >
          <van-tag v-if="item.ExamResult.ERT_Code == 1" round type="danger"
            >不及格</van-tag
          >
          <van-tag v-if="item.ExamResult.ERT_Code == 0" round type="danger"
            >缺考</van-tag
          >
        </li>
        <li v-if="item.ExamBatch.ShowCommentsTime&&(new Date(item.ExamBatch.ShowCommentsTime.replace(/-/g, '/')) < (new Date()))">
                    <label for=""><i class="iconfont icon-chakan"></i>查看评语：</label>
                    <span>
                      <van-button v-if="item.Majors.ParentID==-1" round type="primary" :to="{path:'MIReview', query: {EF_ID :item.EF_ID,CertNO:item.CertNO}}">查看评语</van-button>
                      <van-button v-if="item.Majors.ParentID==-2" round type="primary" :to="{path:'SingReview', query: {EF_ID :item.EF_ID,CertNO:item.CertNO}}">查看评语</van-button>
                    </span>
                </li> 
      </ul>
      <ul v-for="(item, index) in otherResultList" :key="index">
        <li>
          <label for=""><i class="iconfont icon-baoming"></i>报考人：</label>
          <span>{{ item.Name }}</span>
        </li>
        <li>
          <label for=""><i class="iconfont icon-zhuanye"></i>报考专业：</label>
          <span>{{ item.Majors }}</span>
        </li>
        <li>
          <label for=""><i class="iconfont icon-dengji"></i>报考等级：</label>
          <span>{{ item.Grades }}</span>
        </li>
        <li>
          <label for=""><i class="iconfont icon-chengji"></i>考试成绩：</label>
          <van-tag v-if="item.Result == '优秀'" round type="success"
            >优秀</van-tag
          >
          <van-tag v-if="item.Result == '良好'" round type="success"
            >良好</van-tag
          >
          <van-tag v-if="item.Result == '及格'" round type="warning"
            >及格</van-tag
          >
          <van-tag v-if="item.Result == '不及格'" round type="danger"
            >不及格</van-tag
          >
          <van-tag v-if="item.Result == '缺考'" round type="danger"
            >缺考</van-tag
          >
        </li>
      </ul>
      <!-- 如果没有数据时显示 -->
      <van-empty
        description="暂无数据"
        v-if="
          (!resultList || resultList.length == 0) &&
          (!otherResultList || otherResultList.length == 0)
        "
      ></van-empty>
    </div>
  </div>
</template>

<script>
import TopNavBar from "@/components/TopNavBar.vue";
import { ScoreQuery, OtherScoreQuery } from "@/api/exam";
import { Toast } from "vant";
export default {
  components: {
    TopNavBar,
  },
  data() {
    return {
      Name: "",
      CertNO: "",
      ExamFormList: null,
      resultList: null,
      otherResultList: null,
    };
  },
  methods: {
    GetExamList() {
      var loading = Toast.loading({
        message: "正在查询...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      let over = 0;
      if (this.Name == "") {
        loading.clear();
        this.$toast.fail("请输入考生姓名");
        return;
      }
      if (this.CertNO == "") {
        loading.clear();
        this.$toast.fail("请输入考生有效证件号");
        return;
      }
      ScoreQuery({ Name: this.Name, CertNO: this.CertNO }).then((result) => {
        this.resultList = result.listData;
        over++;
        if (over == 2) {
          loading.clear();
        }
      });
      OtherScoreQuery({ Name: this.Name, CertNO: this.CertNO }).then(
        (result) => {
          this.otherResultList = result.listData;
          over++;
          if (over == 2) {
            loading.clear();
          }
        }
      );
    },
  },
};
</script>


<style>
.ExamResultInfo {
  background: url(../assets/kscj.jpg) top no-repeat !important;
  background-size: contain !important;
  min-height: 60vh;
  width: 100%;
}
.ExamResultInfo .van-cell-group {
  margin: 6vh auto 0;
  border-radius: 15px 15px 0 0;
}
.ExamResultInfo .exambatch .van-cell-group .van-cell {
  border-radius: 8px;
}
.ExamResultInfo .exambatch .van-hairline--top-bottom::after,
.ExamResultInfo .exambatch .van-hairline-unset--top-bottom::after {
  border: 0;
}
.ExamResultInfo .ExamResultInfo .van-cell .van-field__left-icon .van-icon {
  font-size: 6vw;
}
.ExamResultbtn {
  padding: 15px 0;
}
.ExamResultbtn .van-button {
  width: 90%;
  background: linear-gradient(to bottom, #07c160, #00b604);
}
.ExamResultbtn p {
  font-size: 3.6vw;
  margin-bottom: 10px;
}
</style>